import { useState } from "react";
import { categories } from "@/mocks/categories";
import { getAllEntries } from "@/hooks/useSiteData";
import EntryCard from "@/components/feature/EntryCard";
import SectionHeading from "@/components/base/SectionHeading";

export default function HotEntries() {
  const [active, setActive] = useState("all");
  const all = getAllEntries();
  const list = active === "all" ? all : all.filter((item) => item.categoryId === active);

  return (
    <section className="border-b border-background-200 bg-background-100/60 px-4 py-12 md:px-6 md:py-16">
      <SectionHeading
        eyebrow="热门词条"
        title="正在被翻看的档案"
        desc="点击标签可以只看某一类话题，词条里的时间线会随最新公开信息更新。"
      />

      <div className="mb-6 flex flex-wrap gap-2">
        <button
          type="button"
          onClick={() => setActive("all")}
          className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
            active === "all"
              ? "bg-primary-500 text-background-50"
              : "bg-background-50 text-foreground-700 hover:bg-primary-100"
          }`}
        >
          全部
        </button>
        {categories.map((cat) => (
          <button
            key={cat.id}
            type="button"
            onClick={() => setActive(cat.id)}
            className={`flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
              active === cat.id
                ? "bg-primary-500 text-background-50"
                : "bg-background-50 text-foreground-700 hover:bg-primary-100"
            }`}
          >
            <i className={cat.icon}></i>
            {cat.name}
          </button>
        ))}
      </div>

      {list.length > 0 ? (
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((entry) => (
            <EntryCard key={entry.id} entry={entry} />
          ))}
        </div>
      ) : (
        <p className="rounded-lg border border-dashed border-background-300 px-4 py-10 text-center text-sm text-foreground-500">
          该分类暂时还没有词条，稍后再来看看
        </p>
      )}
    </section>
  );
}